<template>
	<div class="mx-n3 mt-n4">
		<v-list v-if="data.menus.length > 0" expand>
			<template v-for="(menu, idx) in data.menus">
				<div :key="`nav-section-${menu[0].title}-${idx}`">
					<div v-if="menu.length === 1">
						<!-- Single level entry -->
						<template v-if="menu[0].link">
							<v-list-item
									v-ripple="{ class: 'side-nav-ripple' }"
									:class="[
                  checkRoute(menu[0].link) ? 'v-list-item--active--force' : ''
                ]"
									dense
									:href="menu[0].link"
									:target="menu[0].target ? menu[0].target : ''"
							>
								<v-list-item-icon>
									<v-icon v-if="menu[0].class">
										{{ menu[0].class }}
									</v-icon>
									<i
											v-if="3 === 2"
											:class="[
                      'd-flex align-center justify-center nav-main-link-icon',
                      menu[0].class
                    ]"
									></i>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ menu[0].title }}
									</v-list-item-title>
									<!-- right icon was here -->
								</v-list-item-content>
							</v-list-item>
						</template>

						<!-- This is a section heading -->
						<template v-else>
							<v-list-item class="section-heading grey--text mb-0 mt-4" dense>
								<v-list-item-icon>
									<v-icon color="primary">mdi-rhombus-medium</v-icon>
								</v-list-item-icon>
								<v-list-item-content style="flex: initial">
									<v-list-item-title
											:class="[
                      'font-weight-bold',
                      'text-caption',
                      'text--grey',
                      'text--lighten-3',
                      'text-uppercase'
                    ]"
									>
										{{ menu[0].title }}
									</v-list-item-title>
								</v-list-item-content>
								<v-divider class="flex-grow-1 ms-2 my-0"></v-divider>
							</v-list-item>
						</template>
					</div>

					<!-- Multi-level entry -->
					<div v-else>
						<v-list-group
								:class="checkSubRoute(menu) ? 'v-list-group--active--force' : ''"
								:value="checkSubRoute(menu)"
						>
							<!-- Opener for sub menus -->
							<template v-slot:activator>
								<v-list-item-icon>
									<v-icon>{{ menu[0].class }}</v-icon>
									<i
											v-if="3 === 2"
											:class="[
                      'd-flex align-center justify-center nav-main-link-icon',
                      menu[0].class
                    ]"
									></i>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ menu[0].title }}
									</v-list-item-title>
								</v-list-item-content>
							</template>

							<!-- Sub menu items -->
							<template v-for="(menuItem, idx) in menu">
								<v-list-item
										v-if="idx > 0"
										:key="`nav-sub-item-${menuItem.title}-${idx}`"
										:class="[
                    'sub-item',
                    checkRoute(menuItem.link)
                      ? 'v-list-item--active--force'
                      : ''
                  ]"
										dense
										:href="menu[0].link"
								>
									<v-list-item-icon>
										<v-icon small>{{ menuItem.class }}</v-icon>
										<i
												v-if="3 === 2"
												:class="[
                        'd-flex align-center nav-main-link-icon',
                        menuItem.class
                      ]"
										></i>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											{{ menuItem.title }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider
										v-if="idx === menu.length - 1"
										:key="`nav-sub-item-divider-${menuItem.title}-${idx}`"
										class="mt-2 mx-4"
								/>
							</template>
						</v-list-group>
					</div>
				</div>
			</template>
		</v-list>

		<v-divider class="mb-4 mt-2 mx-3 opacity-70"></v-divider>
	</div>
</template>

<script>
export default {
	name: 'Menus',
	components: {},
	props: {
		data: {
			type: Object,
			default: () => {
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		formIsDirty() {
			return this.$store.state.formState.isDirty;
		}
	},
	methods: {
		checkRoute(route) {
			// Route may or may not be a full url... if not, make it so
			const routeToTest =
					route.indexOf('http') === -1 ? `http://a.b.c${route}` : route;
			const { pathname: routePathname } = new URL(routeToTest);
			const { pathname: currentPathname } = new URL(window.location);
			return routePathname === currentPathname;
		},
		checkSubRoute(menuHeader) {
			if(Array.isArray(menuHeader))
				return menuHeader.some(item => this.checkRoute(item.link));

			return false;
		}
	}
};
</script>

<style lang="scss" scoped>
.v-list {
	background: none !important;
}

.v-list-item:not(.v-list-group__header) {
	&.v-list-item--active--force {
		& .v-icon,
		& .v-list-item__content {
			color: var(--v-primary-darken2);
		}

		&:not(:hover):not(:focus) {
			& .v-icon,
			& .v-list-item__content {
				color: var(--v-primary-base);
			}

			&:before {
				background: var(--v-primary-base);
				opacity: 0.05 !important;
			}
		}

		&:before {
			background: var(--v-primary-base);
			opacity: 0.12 !important;
		}
	}
}

::v-deep .v-list-item {
	border-radius: 0.25rem;
	min-height: 40px !important;
	margin: 0.125rem 0.75rem;
	padding: 0 1rem;

	&--active:not(:hover):not(:focus):before {
		opacity: 0.05 !important;
	}

	&::before {
		border-radius: 0.25rem;
	}
}

.v-list-item .v-list-item__title {
	font-size: 0.8125rem;
}

.v-list-item .v-list-item__content,
.v-list-item__content {
	padding: 8px 0;
}

.v-list-item__icon {
	margin: 8px 0;
}

::v-deep .v-list-group__items .v-list-item {
	margin-left: 3.25rem;
	overflow: visible;
	padding: 0 16px;
}

.v-list-item__icon .v-icon {
	opacity: 0.5;
}

.v-list > div:last-child .v-list-group--active .v-list-group__items hr {
	display: none !important;
}

::v-deep .v-list-group__items .v-list-item__icon::before {
	position: absolute;
	content: '';
	height: 1rem;
	width: 0.5rem;
	border-bottom-left-radius: 6px;
	border-left: dotted 1px #ccc;
	border-bottom: dotted 1px #ccc;
	left: -12px;
	top: 4px;
	opacity: 0;
	transition: opacity 300ms ease-in-out;
}

@for $i from 1 to 12 {
	::v-deep .v-list-group__items {
		& .v-list-item:nth-child(#{$i}) {
			& .v-list-item__icon::before {
				top: #{(($i - 1) * -42) + 4}px;
				height: #{(($i - 1) * 2.6275) + 1}rem;
			}
		}
	}
}

::v-deep .v-list-group__items .v-list-item:hover .v-list-item__icon::before {
	opacity: 1;
}
</style>
